import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Tabs, Spin, Alert } from 'antd'
import CurrentUserContextProvider from 'contexts/currentUserContext'
import AbilityContextProvider from 'contexts/abilityContext'
import { LEGAL_NOTICES_PROVIDERS_QUERY } from 'graphql/LegalNoticesIndex'
import ProviderTable from './components/ProviderTable'

const ACTIVE_TAB_KEY = 'legal_notices_active_tab'

const LegalNotices = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<string>(
    sessionStorage.getItem(ACTIVE_TAB_KEY) || 'internal'
  )

  const { data, loading, error } = useQuery(LEGAL_NOTICES_PROVIDERS_QUERY, {
    fetchPolicy: 'cache-first',
  })

  const handleTabChange = (key: string) => {
    sessionStorage.setItem(ACTIVE_TAB_KEY, key)
    setActiveTab(key)
  }

  const providers: Array<{ key: string; label: string; statuses: string[] }> =
    data?.legalNoticeProviders ?? []

  const tabItems = providers.map(p => ({
    key: p.key,
    label: p.label,
    children: <ProviderTable providerKey={p.key} />,
  }))

  return (
    <CurrentUserContextProvider>
      <AbilityContextProvider>
        <div style={{ padding: '0 24px' }}>
          <h1>Annonces Légales</h1>

          {error && (
            <Alert
              type="error"
              message="Erreur lors du chargement des providers"
              style={{ marginBottom: 16 }}
            />
          )}

          {loading ? (
            <Spin />
          ) : (
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              destroyInactiveTabPane
              items={tabItems}
            />
          )}
        </div>
      </AbilityContextProvider>
    </CurrentUserContextProvider>
  )
}

export default LegalNotices
